import betweenAiTeams from "./betweenAiTeams.ts";
import clear from "./clear.ts";
import create from "./create.ts";
import get from "./get.ts";
import getOtherTid from "./getOtherTid.ts";
import getPickValues from "./getPickValues.ts";
import isUntradable from "./isUntradable.ts";
import makeItWork from "./makeItWork.ts";
import makeItWorkTrade from "./makeItWorkTrade.ts";
import processTrade from "./processTrade.ts";
import propose from "./propose.ts";
import summary from "./summary.ts";
import updatePlayers from "./updatePlayers.ts";

export default {
	betweenAiTeams,
	clear,
	create,
	get,
	getOtherTid,
	getPickValues,
	isUntradable,
	makeItWork,
	makeItWorkTrade,
	processTrade,
	propose,
	summary,
	updatePlayers,
};
